import { ajax } from './http.js'    

export const getDownUrl = (fn) => {
    ajax({
        url: '/versionary/app/version/last/version/langwise/all',
        method: 'get',
        success: (res) => {
            fn(res);
        },
        error: (err) => {
            console.error('获取下载链接失败:', err)
        }
    });
}
